import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, ModelDataService, DropdownPicklistComponent, ConfirmationDialogButtons, DatePickerPopup2Component, UserRightsService, ErrorHandlerService, NotificationService, DateTimePickerPopupComponent, InlineContainerService, BaseInlineContainer } from 'yt-ng-framework';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, Validators } from '@angular/forms';
import { PodVrstaDokumentaStavkaView } from 'src/app/lookups/podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/admin/company/company';
import { TipOtpremnice } from '../tip-otpremnice/tip-otpremnice';
import { NacinOtpreme } from '../nacin-otpreme/nacin-otpreme';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { CompanyView } from 'src/app/admin/company/company-view';
import { FirmaObjekat } from 'src/app/admin/company/firma-objekat/firma-objekat';
import { FirmaObjekatView } from 'src/app/admin/company/firma-objekat/firma-objekat-view';
import { KomitentObjekatView } from 'src/app/lookups/komitent-objekat/komitent-objekat-view';
import { EPrijemnica } from './eprijemnica';
import { NgZone } from '@angular/core';
import { EPrijemnicaView } from './eprijemnica-view';

@Component({
    selector: 'yt-eprijemnica-update',
    templateUrl: './eprijemnica-update.component.html'
})
export class EPrijemnicaUpdateComponent extends BaseUpdateComponent<EPrijemnica>
    implements OnInit {
    izlazna: boolean = false;
    podvrstaDokumentaGn: string = null;
    varConfig = var_config;
    parameterList: List<QueryParameter> = List([]);
    angazovanPrevoznik: boolean;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected router: Router,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modelDataService: ModelDataService,
        protected userRightsService: UserRightsService,
        protected errorService: ErrorHandlerService
        , private ngZone: NgZone

    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService, router)
    }
    collapsedOtpremnica: boolean = false;
    collapsedDetaljiOOtpremnici: boolean = true;
    collapsedDetaljiOPosiljaocu: boolean = true;
    collapsedDetaljiOOtpremi: boolean = true;
    collapsedDetaljiOPrimaocu: boolean = true;
    collapsedDetaljiODostavi: boolean = true;

    @ViewChild('dtpDatumDokumenta', { static: true }) dtpDatumDokumenta: DatePickerPopup2Component;
    @ViewChild('prevozInline', { static: true }) prevozInline: any;
    @ViewChild('formTop', { static: false }) formTop: ElementRef;

    @ViewChild('baseInlineContainer', { static: false }) baseInlineContainer: BaseInlineContainer<EPrijemnica>;
    @ViewChild('baseInlineContainer1', { static: false }) baseInlineContainer1: BaseInlineContainer<EPrijemnica>;
    @ViewChild('baseInlineContainer2', { static: false }) baseInlineContainer2: BaseInlineContainer<EPrijemnica>;

    ngOnInit() {
        super.ngOnInit();
        this.izlazna = this.modelData.MainTitle === 'Izlazna prijemnica';
        // 7.11.2025
        let parameterList: List<QueryParameter> = List(this.modelData.MainList.GetParameters);
        this.TransferParameters = this.TransferParameters.set(0, parameterList);

        parameterList.clear();
        parameterList = List([new QueryParameter('Izlazna', this.izlazna)]);
        this.TransferParameters = this.TransferParameters.set(1, parameterList);

          parameterList.clear();
        parameterList = List([new QueryParameter('Locked', !this.Item?.Editable)]);
        this.TransferParameters = this.TransferParameters.set(2, parameterList);


        this.IDProcessed
            .subscribe((value) => {

                if (value && this.Item.ID == -1) {
                    this.collapsedOtpremnica = false;
                    this.collapsedDetaljiOOtpremnici = true;
                    this.collapsedDetaljiOPosiljaocu = true;
                    this.collapsedDetaljiOOtpremi = true;
                    this.collapsedDetaljiOPrimaocu = true;
                    this.collapsedDetaljiODostavi = true;
                    this.enableControls();
                }
                else {
                    //this.angazovanPrevoznik = value.Prevoznik;
                    this.angazovanPrevoznik = true;
                    this.collapsedOtpremnica = true;
                    this.collapsedDetaljiOOtpremnici = false;
                    this.collapsedDetaljiOPosiljaocu = false;
                    this.collapsedDetaljiOOtpremi = false;
                    this.collapsedDetaljiOPrimaocu = false;
                    this.collapsedDetaljiODostavi = false;
                    this.disableControls();
                    if (this.Item.ID > 0) {
                        this.scrollToFormTopDeferred();
                    }
                }

            })

        let _this = this;
        this.ItemSaved
            .subscribe((data: EPrijemnicaView) => {
                this.disableControls();
                this.baseDataService.GetByID(this.modelData.MainList.ModelName, data.ID, this.modelData.MainList.ModelClass)
                    .subscribe((eprijemnica: EPrijemnica) => {
                        _this.Item = eprijemnica;
                        _this.baseFormGroup.patchValue(_this.Item);
                        _this.SavedItem = _this.baseFormGroup.getRawValue();

                    })

            })

    }

    disableControls() {
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        this.baseFormGroup.get('Broj').disable();
        this.baseFormGroup.get('Broj').updateValueAndValidity();
        this.baseFormGroup.get('BrojUlazneOtpremnice').disable();
        this.baseFormGroup.get('BrojUlazneOtpremnice').updateValueAndValidity();
        this.baseFormGroup.get('BrojOtpremnice').disable();
        this.baseFormGroup.get('BrojOtpremnice').updateValueAndValidity();
        this.baseFormGroup.get('DatumOtpremnice').disable();
        this.baseFormGroup.get('DatumOtpremnice').updateValueAndValidity();
        this.baseFormGroup.get('TipOtpremnice').disable();
        this.baseFormGroup.get('TipOtpremnice').updateValueAndValidity();
        this.baseFormGroup.get('NacinOtpreme').disable();
        this.baseFormGroup.get('NacinOtpreme').updateValueAndValidity();
        this.baseFormGroup.get('BrojUlaznePrijemnice').disable();
        this.baseFormGroup.get('BrojUlaznePrijemnice').updateValueAndValidity();
        this.baseFormGroup.get('StvarnoVremeDostave').disable();
        this.baseFormGroup.get('StvarnoVremeDostave').updateValueAndValidity();
        if (!this.izlazna){
            this.baseFormGroup.get('Datum').disable();
            this.baseFormGroup.get('Datum').updateValueAndValidity();
        }
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
    }

    enableControls() {
        this.baseFormGroup.enable();
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);

    }

    private scrollToFormTopDeferred(): void {
        this.changeDetectorRef.detectChanges();

        this.ngZone.runOutsideAngular(() => {
            requestAnimationFrame(() => {
                this.scrollToTopNow();

                setTimeout(() => this.scrollToTopNow(), 50);
                setTimeout(() => this.scrollToTopNow(), 150);
                setTimeout(() => this.scrollToTopNow(), 300);
            });
        });
    }
    private scrollToTopNow(): void {
        const topEl = this.formTop?.nativeElement as HTMLElement | null;

        if (topEl) {
            topEl.scrollIntoView({
                behavior: 'auto',
                block: 'start',
                inline: 'nearest'
            });
        }

        window.scrollTo(0, 0);

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        const scrollableParent = this.findScrollableParent(topEl);
        if (scrollableParent) {
            scrollableParent.scrollTop = 0;
        }
    }
    private findScrollableParent(el: HTMLElement | null): HTMLElement | null {
        let parent = el?.parentElement;

        while (parent) {
            const style = window.getComputedStyle(parent);
            const overflowY = style.overflowY;

            if ((overflowY === 'auto' || overflowY === 'scroll') &&
                parent.scrollHeight > parent.clientHeight) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return null;
    }
    onRestoreClick(): void {
        this.Reset(true).subscribe((result) => {
            if (result) {
                //console.log('Restore successfully executed');
            } else {
                //console.log('Restore was cancelled by the user');
            }
        });
    }

    private scrollFormToTop(times = 6, delay = 80) {
        if (!this.formTop?.nativeElement) {
            return;
        }

        this.ngZone.runOutsideAngular(() => {
            let count = 0;
            const timer = setInterval(() => {
                this.formTop.nativeElement.scrollIntoView({
                    behavior: 'auto',
                    block: 'start'
                });
                count++;
                if (count >= times) {
                    clearInterval(timer);
                }
            }, delay);
        });
    }

    toggleCollapseOtpremnica(event?: MouseEvent) {
        if (this.izlazna) {
            if (event) {
                event.stopPropagation(); // spreči dupli click
            }
            this.collapsedOtpremnica = !this.collapsedOtpremnica
        }
    }
    toggleCollapseDetaljiOOtpremnici(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOOtpremnici = !this.collapsedDetaljiOOtpremnici
    }
    toggleCollapseDetaljiOPosiljaocu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOPosiljaocu = !this.collapsedDetaljiOPosiljaocu;
    }
    toggleCollapseDetaljiOOtpremi(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOOtpremi = !this.collapsedDetaljiOOtpremi;
    }
    toggleCollapseDetaljiOPrimaocu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOPrimaocu = !this.collapsedDetaljiOPrimaocu
    }
    toggleCollapseDetaljiODostavi(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiODostavi = !this.collapsedDetaljiODostavi;
    }


}